const es = {
  common: {
    search: "Buscar...",
    export: "Exportar",
    columns: "Columnas",
    all: "Todas",
    cancel: "Cancelar",
    save: "Guardar",
    saveChanges: "Guardar cambios",
    discardChangesTitle: "¿Descartar cambios?",
    discardChangesDesc: "Tienes cambios sin guardar. Si sales ahora se perderán.",
    discard: "Descartar",
    keepEditing: "Seguir editando",
    noResultsFor: "Sin resultados para",
    clearFilters: "Limpiar filtros",
    loading: "Cargando...",
    backToHome: "Volver al inicio",
    viewAll: "Ver todo",
    actions: "Acciones",
    edit: "Editar",
    view: "Ver detalle",
    delete: "Eliminar",
    new: "Nuevo",
    status: "Estado",
    date: "Fecha",
    client: "Cliente",
    confirm: "Confirmar",
    close: "Cerrar",
    emptyCell: "-",
    moreOptions: "Más opciones",
    resumen: "Resumen",
    switchToDarkMode: "Cambiar a modo oscuro",
    switchToLightMode: "Cambiar a modo claro",
    logout: "Cerrar sesión",
    logoutConfirmTitle: "¿Cerrar sesión?",
    logoutConfirmText: "Estás por salir de la intranet. ¿Deseas continuar?",
    language: "Idioma",
    appearance: "Apariencia",
    appearanceSystem: "Sistema",
    appearanceLight: "Claro",
    appearanceDark: "Oscuro",
    myAccount: "Mi cuenta",
    notifications: "Notificaciones",
    role: "Rol",
    collapseMenu: "Colapsar menú",
    expandMenu: "Expandir menú",
  },
  status: {
    "sin-iniciar": "Sin iniciar",
    "en-desarrollo": "En desarrollo",
    finalizada: "Finalizada",
    liquidada: "Liquidada",
    anulada: "Anulada",
    "por-liquidar": "Por liquidar",
    pendiente: "Pendiente",
    activo: "Activo",
    inactivo: "Inactivo",
    disponible: "Disponible",
    "stock-bajo": "Stock bajo",
    "sin-stock": "Sin stock",
    normal: "Normal",
    atraso: "Atraso",
    ausencia: "Ausencia",
    incompleta: "Incompleta",
    "fin-de-semana": "Fin de semana",
  },
  nav: {
    groupOperacion: "Operación",
    groupInventario: "Inventario",
    groupPersonal: "Personal",
    groupRecursos: "Inventario",
    groupPersonas: "Personal",
    groupAdministracion: "Administración",
    dashboard: "Dashboard",
    ordenes: "Órdenes de servicio",
    liquidacion: "Liquidación",
    bodega: "Bodega",
    proveedores: "Proveedores",
    asistencia: "Asistencia",
    trabajadores: "Trabajadores",
    clientes: "Clientes",
    perfiles: "Perfiles",
    configuracion: "Configuración",
  },
  topbar: {
    searchPlaceholder: "Buscar en la intranet...",
    notifications: "Notificaciones",
  },
  emptyStates: {
    noData: "No hay registros para mostrar",
    noResults: "Sin resultados",
    createAction: "Crear el primero",
  },
  datos: {
    guardando: "Guardando…",
    guardado: "Guardado",
    errorGuardar: "No se pudo guardar. Reintentando…",
    conflicto: "Otra persona modificó esto al mismo tiempo; se cargó su versión.",
    numeroCambiado: "Ese número de orden ya existía; se asignó el siguiente disponible.",
    cerrar: "Cerrar aviso",
  },
  login: {
    welcomeTitle: "Intranet SEAELEC",
    subtitle: "Ingrese con su cuenta de Google de la empresa",
    googleSignIn: "Acceder con Google",
    orDivider: "o",
    rutToggle: "Ingresar con RUT y contraseña",
    rutHint: "Para cuentas sin correo de Google de la empresa",
    googleOnlyNote: "Solo pueden ingresar las cuentas de Google de la empresa que tengan acceso a la intranet.",
    googleErrorTitle: "No se pudo ingresar con Google",
    googleErrorCancelado: "Se canceló el inicio de sesión con Google. Puede intentarlo de nuevo.",
    googleErrorSinAlta: "Su cuenta de Google no tiene acceso a la intranet. Pida el alta a un administrador.",
    googleErrorDominio: "Use su cuenta de Google de la empresa; las cuentas personales no tienen acceso.",
    googleErrorInactivo: "Su usuario está desactivado. Contacte a un administrador.",
    googleErrorFallo: "Ocurrió un problema al validar su cuenta. Inténtelo de nuevo en unos minutos.",
    rutLabel: "RUT",
    rutPlaceholder: "12.345.678-9",
    rutInvalid: "Revise el RUT: no es válido",
    required: "Complete este campo",
    passwordLabel: "Contraseña",
    passwordPlaceholder: "Ingrese su contraseña",
    showPassword: "Mostrar contraseña",
    hidePassword: "Ocultar contraseña",
    forgotPassword: "¿Olvidó su contraseña?",
    signIn: "Iniciar sesión",
    signingIn: "Iniciando sesión…",
    invalidCredentials: "El RUT o la contraseña no coinciden. Revise ambos e inténtelo de nuevo.",
    supportQuestion: "¿Necesita asistencia técnica?",
    copyright: "© 2026 SEAELEC SpA. Todos los derechos reservados.",
    languageSpanish: "Español",
    languageEnglish: "English",
    languageLabel: "Idioma",
    logoAlt: "SEAELEC",

    forgotTitle: "Recuperar contraseña",
    forgotSubtitle: "Ingrese su RUT y le enviaremos un correo para restablecer su contraseña",
    sendInstructions: "Enviar instrucciones",
    sending: "Enviando…",
    backToLogin: "Volver a iniciar sesión",

    checkEmailTitle: "Revise su correo",
    checkEmailText:
      "Si el RUT tiene una cuenta, le enviamos un correo con un enlace para restablecer su contraseña",

    newPasswordTitle: "Nueva contraseña",
    newPasswordSubtitle: "Use al menos 8 caracteres",
    newPasswordLabel: "Nueva contraseña",
    confirmPasswordLabel: "Confirmar contraseña",
    errorMismatch: "Las contraseñas no coinciden",
    errorLength: "Use al menos 8 caracteres",
    resetButton: "Restablecer contraseña",
    resetting: "Restableciendo…",

    successTitle: "Contraseña actualizada",
    successText: "Ya puede ingresar con su nueva contraseña",
    goToLogin: "Ir a iniciar sesión",

    errorTitle: "Este enlace ya no es válido",
    errorText: "El enlace para restablecer su contraseña venció o ya se usó. Solicite uno nuevo.",
    requestNewLink: "Solicitar nuevo enlace",

    demoSimTitle: "Demostración: abrir el enlace del correo",
    demoSimValid: "Enlace vigente",
    demoSimExpired: "Enlace vencido",
  },
};

export default es;
export type Dictionary = typeof es;
